import { Component, inject } from '@angular/core';
import {MAT_SNACK_BAR_DATA, MatSnackBarRef} from '@angular/material/snack-bar';
import {Notification} from './notification';

@Component({
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
    standalone: false
})
export class NotificationComponent {
  private snackBar = inject<MatSnackBarRef<NotificationComponent>>(MatSnackBarRef);
  notification = inject<Notification>(MAT_SNACK_BAR_DATA);

  getIcon(): string {
    return {
      success: 'check_circle',
      info: 'info',
      warn: 'warning',
      error: 'error'
    }[this.notification.level];
  }

  close(): void {
    this.snackBar.dismiss();
  }
}
